import { TEDFormatIntAsFloat } from './TEDFormatIntAsFloat';
import { TEDDisplayPercent } from '../Displayers/TEDDisplayPercent';
import { TEDParsePercent } from '../Parsers/TEDParsePercent';

class TEDFormatIntAsPercent extends TEDFormatIntAsFloat {
  parser = TEDParsePercent.getInstance();
  displayer = TEDDisplayPercent.getInstance();
}

export { TEDFormatIntAsPercent };
